<template>
  <div id="group">
    <div class="container">
      <el-image :src="src1" style="height: 350px;"/>
      <div style="text-align: left;line-height: 28px">
        <h3>1、功能介绍</h3>
        <p>针对【Word转双层PDF】【PDF转双层PDF】两个常用且耗时较长的转换功能，尤其页数2000以上的文档，一台电脑
          转换一般耗时在2个小时以上，本功能通过自动将多台电脑组合同时转换，充分利用电脑资源，加速文档转换效率。经测试，
          在<span class="text-red">8核 i7-1195G7 @ 2.90GHz处理器</span>的5台电脑同时参与转换下，一个2000页文档预估
          20分钟左右完成转换，具体耗时与电脑系统性能、使用情况存在部分差异。</p>
        <p></p>
        <h3>2、应用场景？</h3>
        <p>建议<span class="text-red">最少3台电脑以上</span>使用，主要面向经常使用上述两个功能、可自由控制多台电脑资源的<span class="text-red">企业用户</span>。</p>
        <p></p>
        <h3>3、如何使用？</h3>
        <p>▶ 首页点击【集团用户】登录，输入集团号、手机号、验证码登录：</p>
        <el-image :src="img_group1" style="height: 350px;margin-left: 100px"/>
        <el-image :src="img_group2" style="height: 350px;margin-left: 100px"/>
        <p>▶ 登录后，在首页出现【集团设置】，点击完成相关设置：</p>
        <el-image :src="img_group3" style="height: 350px;margin-left: 100px"/>
        <el-image :src="img_group4" style="height: 350px;margin-left: 100px"/>
        <p>▶ 在转换时，选择【启用多电脑加速转换】即可：</p>
        <el-image :src="img_group5" style="height: 350px;margin-left: 100px"/>
        <p></p>
        <h3>4、如何购买？</h3>
        <p>由于集团用户场景需技术人员到现场进行本地电脑参数配置等，无法直接安装使用，因此暂不支持在线购买，如需购买请先联系QQ客服咨询。
          购买规则：金额 = 300元/每台电脑每年 * 电脑数（至少3台以上） + 技术支持服务费（一次性，面议）。</p>
        <el-image :src="img_qq" style="height: 350px;margin-left: 100px"/>
      </div>
    </div>
  </div>
</template>

<script>
import img1 from '@/assets/images/group.png'
import group1 from '@/assets/images/group1.png'
import group2 from '@/assets/images/group2.png'
import group3 from '@/assets/images/group3.png'
import group4 from '@/assets/images/group4.png'
import group5 from '@/assets/images/group5.png'
import qq from '@/assets/images/help.jpg'
export default {
  name: 'Group',
  components: {
    // HelloWorld,
    // FixedHeader
  },
  data() {
    return {
      tableData: [],
      src1: img1,
      img_group1: group1,
      img_group2: group2,
      img_group3: group3,
      img_group4: group4,
      img_group5: group5,
      img_qq: qq
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
#group {
  position: relative;
  width: calc(100vw - 60px);
  //height: calc(100vh - 220px);
  top: 45px;
  padding: 30px;
  background: #f0f0f0;
}
.container{
  background: white;
  margin-left: calc((100vh - 475px) / 2);
  margin-right: calc((100vh - 475px) / 2);
  margin-bottom: 10px;
  border-radius: 10px;
  padding-left: 30px;
  padding-right: 20px;
  padding-bottom: 40px;
  //height: calc(100vh - 260px);

  ////position: relative;
  //width: calc(100vw);
  ////height: calc(100vh - 220px);
  //background: #f0f0f0;
  //margin-top: 0px;
}
.text-red{
  color: #ff4d4f;
}
</style>
